import { render } from "./TopCompanies.vue?vue&type=template&id=0b006abd&scoped=true"
const script = {}

import "./TopCompanies.vue?vue&type=style&index=0&id=0b006abd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b006abd"]])

export default __exports__